export default __webpack_public_path__ + "static/media/Portfolio.bde819e7.png";